"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeBundleForPolkadot = exports.types19 = exports.types = void 0;
const zero_1 = require("./zero");
const hyperspace_1 = require("./hyperspace");
const gamedao_1 = require("./gamedao");
const sensenet_1 = require("./sensenet");
exports.types = Object.assign(Object.assign(Object.assign(Object.assign({}, zero_1.zero), sensenet_1.sensenet), hyperspace_1.hyperspace), gamedao_1.gamedao);
exports.types19 = Object.assign({}, exports.types);
exports.typeBundleForPolkadot = {
    types: [
        {
            minmax: [0, 18],
            types: exports.types,
        },
        {
            minmax: [19, undefined],
            types: exports.types19,
        },
    ],
};
